import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=2dff0d6b&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dff0d6b')) {
      api.createRecord('2dff0d6b', component.options)
    } else {
      api.reload('2dff0d6b', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=2dff0d6b&", function () {
      api.rerender('2dff0d6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/loading/src/loading.vue"
export default component.exports